import styled from 'styled-components'
import { theme } from '../../theme'

const Paragraph = styled.p`
  font-weight: 300;
  font-size: 14px;
  color: #222;
  letter-spacing: 1.23px;
  display: block;
  margin: 0;

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin-top: 10px;
  }
`
export { Paragraph }
